import composeGlobalSuccessMessaging from 'app/helpers/messaging/composeGlobalSuccessMessaging';
import FlagsApi from '../api/FlagsApi';
import FlagsConstants from '../constants/FlagsConstants';

function addFlag({ contentId, userId, flagType, reason, violationType, postSuccess }) {
  return {
    contentId,
    types: [FlagsConstants.ADD_FLAG_REQUEST, FlagsConstants.ADD_FLAG_SUCCESS, FlagsConstants.ADD_FLAG_FAILURE],
    apiRequest: (_state, client) => FlagsApi.addFlag({ contentId, userId, flagType, reason, violationType }, client),
    apiSuccess: () => {
      return {
        messaging: composeGlobalSuccessMessaging('message_content_flag_submitted', {
          defaultMessage: 'Content flag submitted'
        })
      };
    },
    postSuccess
  };
}

export default {
  addFlag
};
